import { useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

// Só contas novas têm email_verified = false; contas antigas não veem o aviso.
export default function EmailVerificationBanner() {
  const { user } = useAuth();
  const [sending, setSending] = useState(false);
  if (!user || user.email_verified !== false) return null;
  const resend = async () => {
    setSending(true);
    try {
      await api.post("/auth/verify-email/resend");
      toast.success(`Enviamos um novo link para ${user.email}.`);
    } catch (error) {
      toast.error(error?.response?.data?.detail || "Não foi possível reenviar agora.");
    } finally {
      setSending(false);
    }
  };
  return (
    <div role="status" data-testid="email-verification-banner" className="mb-4 rounded-xl border border-warning/40 bg-warning/10 p-3 text-sm flex flex-wrap items-center justify-between gap-2">
      <span>Confirme seu e-mail: enviamos um link para <strong>{user.email}</strong>.</span>
      <button type="button" className="text-cyan font-semibold" onClick={resend} disabled={sending}>{sending ? "Enviando…" : "Reenviar link"}</button>
    </div>
  );
}
